import { render, staticRenderFns } from "./icBookingBasic.vue?vue&type=template&id=7707e318&scoped=true&"
import script from "./icBookingBasic.vue?vue&type=script&lang=js&"
export * from "./icBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./icBookingBasic.vue?vue&type=style&index=0&id=7707e318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7707e318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7707e318')) {
      api.createRecord('7707e318', component.options)
    } else {
      api.reload('7707e318', component.options)
    }
    module.hot.accept("./icBookingBasic.vue?vue&type=template&id=7707e318&scoped=true&", function () {
      api.rerender('7707e318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/icBookingBasic.vue"
export default component.exports